import { render, staticRenderFns } from "./TeacherAccountInfo.vue?vue&type=template&id=76d01147&scoped=true"
import script from "./TeacherAccountInfo.vue?vue&type=script&lang=js"
export * from "./TeacherAccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d01147",
  null
  
)

export default component.exports